import { render, staticRenderFns } from "./SocialMediaSettings.vue?vue&type=template&id=f8244f5a&"
import script from "./SocialMediaSettings.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports